import HypurCheckout from './HypurCheckout.react';
import CanPayCheckout from './CanPayCheckout.react';
import LinxCheckout from './LinxCheckout.react';

class ElectronicCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            clients: [],
            selectedClient: null,
            pin: ''
        };

        this.cancel = this.cancel.bind(this);
    }

    cancel() {
        this.props.onCancel();
    }

    render() {
        var guest = this.props.guest;
        var valid = this.state.pin.length > 0;
        var CheckoutComponent = null;
        switch(this.props.type) {
            case 'hypur':
                CheckoutComponent = HypurCheckout;
                break;
            case 'canpay':
                CheckoutComponent = CanPayCheckout;
                break;
            case 'linx': 
                CheckoutComponent = LinxCheckout;
                break;
            default: 
                return <div>Unknown payment type {this.props.type}</div>
        }

        return (<CheckoutComponent
            onComplete={this.props.onComplete}
            onCancel={this.props.onCancel}
            guest={this.props.guest}
            cart={this.props.cart}
        />);
    }
}

export default ElectronicCheckout;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/electronic/ElectronicCheckout.react.jsx